/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerCreateMutationRequest, DocumentsControllerCreateMutationResponse, DocumentsControllerCreate400, DocumentsControllerCreate401, DocumentsControllerCreate403 } from "../../models/documentsController/DocumentsControllerCreate";

function getDocumentsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/documents` as const }  
  return res
}

/**
 * @summary Create a new document
 * {@link /api/v1/documents}
 */
export async function documentsControllerCreate(data?: DocumentsControllerCreateMutationRequest, config: Partial<RequestConfig<DocumentsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DocumentsControllerCreateMutationResponse, ResponseErrorConfig<DocumentsControllerCreate400 | DocumentsControllerCreate401 | DocumentsControllerCreate403>, DocumentsControllerCreateMutationRequest>({ method : "POST", url : getDocumentsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}